module.exports = __webpack_public_path__ + "static/media/corcom.d14cc19f.png";